import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BookingRedirectComponent } from './booking-redirect/booking-redirect.component';
import { FaqSectionComponent } from './faq-section/faq-section.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { OrderDetailsComponent } from './order-details/order-details.component';
import { PageNotFoundComponent } from './shared/page-not-found/page-not-found.component';
import { TrackMyAppointmentComponent } from './track-my-appointment/track-my-appointment.component';
import { TrackingHistoryComponent } from './tracking-history/tracking-history.component';
import { TrackingRedirectComponent } from './tracking-redirect/tracking-redirect.component';
import { UpdateOrderDetailsComponent } from './update-order-details/update-order-details.component';

const routes: Routes = [
	{
		path: '', component: LandingPageComponent, pathMatch: 'full'
	},
	{
		path: 'tracking', component: LandingPageComponent
	},
	{
        path: 'tracking/:upi',
		component: LandingPageComponent
	},
	{
		path: 'tracking-history',
		component: TrackingHistoryComponent
	},
	{
		path: 'TRK/:upi/:postcode',
		component: TrackingRedirectComponent
	},
	{
		path: 'trk/:upi/:postcode',
		component: TrackingRedirectComponent
	},
	{
		path: 'booking/:orderNumber',
		component: BookingRedirectComponent
	},
	{
		path: 'order-details',
		component: OrderDetailsComponent
	},
	{
		path: 'update-order-details',
		component: UpdateOrderDetailsComponent
	},
	{
		path: 'track-my-appointment',
		component: TrackMyAppointmentComponent
	},
	{
		path: 'faq',
		component: FaqSectionComponent
	},
	{
		path: '**',
		component: PageNotFoundComponent
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { paramsInheritanceStrategy: 'always' })],
	exports: [RouterModule],
	providers: [],
})
export class AppRoutingModule { }
